export const Flight = "flight";
export const Visa = "visa";
export const Hotel = "hotel";
export const Transportation = "transportation";
export const Registration = "registration";